"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.facebookAdsListAccounts = exports.facebookAdsListAccountsResultSchema = exports.facebookAdsListAccountsArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.facebookAdsListAccountsArgsSchema = zod_1.z.object({
    emitMode: zod_1.z.literal('single'),
});
exports.facebookAdsListAccountsResultSchema = zod_1.z.object({
    accounts: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string().describe('Ad account ID'),
        name: zod_1.z.string().describe('Ad account name'),
    })),
});
exports.facebookAdsListAccounts = (0, common_1.createToolMetadata)({
    id: 'facebookAdsListAccounts',
    displayName: 'List Facebook Ad Accounts',
    displayDescription: 'List all accessible Facebook ad accounts',
    category: 'ads',
    color: common_1.BRAND_COLORS.META,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.META),
    icon: 'meta',
    argsSchema: exports.facebookAdsListAccountsArgsSchema,
}, exports.facebookAdsListAccountsResultSchema);
